import React from 'react';
import { founderMessage } from '../data/mockData';

const FounderSection = () => {
  return (
    <section className="bg-white py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-start">
          {/* Founder Image */}
          <div className="relative">
            <img
              src={founderMessage.founderImage}
              alt="Founder - Captain Aravind"
              className="w-full h-[650px] object-cover rounded-lg shadow-xl"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-black/80 p-4 rounded-lg">
              <p className="text-white text-sm italic">
                "The pitch doesn't care about your background - it only rewards hard work and dedication."
              </p>
              <p className="text-yellow-400 text-xs mt-2">— Captain Aravind</p>
            </div>
          </div>

          {/* Founder Message */}
          <div className="py-4">
            <h2 className="text-3xl font-bold text-black mb-10 tracking-[0.05em] leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
              {founderMessage.title}
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed text-sm">
              &ldquo;{founderMessage.quote}&rdquo;
            </p>
            <p className="text-gray-900 font-semibold mb-8 leading-relaxed text-sm border-l-4 border-black pl-5 py-2">
              &ldquo;{founderMessage.highlight}&rdquo;
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed text-sm">
              {founderMessage.continuation}
            </p>
            <p className="text-gray-600 leading-relaxed text-sm">
              {founderMessage.closing}
            </p>
            
            {/* Mental Wellness Link */}
            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-600">
                <span className="font-semibold">Mental wellness is key to cricket success.</span>{' '}
                Check out{' '}
                <a 
                  href="https://breatheflow.live" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline font-medium"
                >
                  Breatheflow.live
                </a>{' '}
                for guided breathing and mindfulness exercises.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
